import { IconProps } from "./types";

export const CloseIcon: React.FC<IconProps> = ({ uuid, fillColor }) => {
  return (
    <svg
      id={`close-icon-${uuid}`}
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id={`close-icon-path-${uuid}`}
        d="M7.25373 6.49503L11.7313 2.02113C12.0896 1.66321 12.0896 1.12635 11.7313 0.768434C11.3731 0.410522 10.8358 0.410522 10.4776 0.768434L6 5.24234L1.52239 0.768434C1.16418 0.410522 0.626866 0.410522 0.268657 0.768434C-0.0895522 1.12635 -0.0895522 1.66321 0.268657 2.02113L4.74627 6.49503L0.268657 10.9689C-0.0895522 11.3268 -0.0895522 11.8637 0.268657 12.2216C0.626866 12.5795 0.716418 12.4901 0.895523 12.4901C1.07463 12.4901 1.34328 12.4901 1.52239 12.2216L6 7.74772L10.4776 12.2216C10.6567 12.4006 10.9254 12.4901 11.1045 12.4901C11.2836 12.4901 11.5522 12.4901 11.7313 12.2216C12.0896 11.8637 12.0896 11.3268 11.7313 10.9689L7.25373 6.49503Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
